import { PostHogProvider } from '@posthog/react';
import posthog from 'posthog-js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { getLangBasename } from './utils/i18n/langBasename';

import { ensureLiveSessionInited } from './utils/cookieConsentServices';
import './utils/i18n/i18n';

// LiveSession: init at bootstrap so it's loaded before Layout calls identify/newPageView
ensureLiveSessionInited();

// GTM is initialized only when user accepts analytics (see cookieConsentServices)

const posthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_PUBLIC_POSTHOG_HOST;

if (!posthogKey || !posthogHost) {
  console.warn('PostHog not initialized: missing variables');
} else {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    defaults: '2026-01-30',
    opt_out_capturing_by_default: false, // opt-out: capture by default, disable when user rejects analytics
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <BrowserRouter basename={getLangBasename()}>
        <App />
      </BrowserRouter>
    </PostHogProvider>
  </React.StrictMode>,
);
